import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            {/* Brand */}
            <div className="lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-fire-line text-lg text-white"></i>
                </div>
                <span className="font-heading text-xl font-bold text-white">
                  黑料网
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed">
                专注于娱乐圈、网红明星黑料爆料的内容聚合平台，汇集最新最全的黑料资讯、独家爆料内容。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors" aria-label="抖音">
                  <i className="ri-tiktok-line"></i>
                </a>
              </div>
            </div>

            {/* Categories */}
            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">
                内容分类
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">
                快速链接
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/category/dujia-neirong" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                    独家内容
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">
                联系我们
              </h4>
              <ul className="space-y-2.5">
                <li className="flex items-start gap-2 text-sm text-foreground-400">
                  <i className="ri-mail-line mt-0.5 text-foreground-500"></i>
                  <span>tips@heiliaowang.com</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-foreground-400">
                  <i className="ri-phone-line mt-0.5 text-foreground-500"></i>
                  <span>400-888-6666</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-foreground-400">
                  <i className="ri-map-pin-line mt-0.5 text-foreground-500"></i>
                  <span>北京市朝阳区光华路88号</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom */}
          <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 黑料网 HeiLiaoWang.com 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">用户协议</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}